import { Box, Grid, Typography } from "@mui/material";
import { Details } from "../Icon";
import makeStyles from '@mui/styles/makeStyles';
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  mainTypography: {
    fontSize: 17,
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secondTypography: {
    fontSize: 14,
    fontWeight: 600,
    color: "#979797",
  },
  boldTypography: {
    fontSize: 14,
    fontWeight: 600,
    color: "#4B4B4B",
  },
  typography: {
    fontSize: 14,
    fontWeight: 400,
    color: "#4B4B4B",
  },
  icon: {
    marginTop: 10,
  },
}));

const ProposalDetails = (props) => {
  const classes = useStyles();
  const { proposalReferee } = props;
  const [proposalId, setProposalId] = useState();
  const [proposalTitle, setProposalTitle] = useState();
  const [submittedBy, setSubmittedBy] = useState();
  const [evaluateBy, setEvaluateBy] = useState();

  useEffect(() => {
    if (proposalReferee === null || proposalReferee === undefined) return;
    setProposalId(proposalReferee.proposalIdNumber);
    setProposalTitle(proposalReferee.proposalTitle);
    setSubmittedBy(proposalReferee.nameOfThePersonThatRecommended);
    setEvaluateBy(proposalReferee.contactName);
  }, [proposalReferee]);

  return (
    <Box border={"0px red solid"} margin={3}>
      <Grid container spacing={1}>
        <Grid item xs={1}>
          <Details className={classes.icon} />
        </Grid>
        <Grid item xs={10}>
          <Box textAlign="left" marginLeft={3}>
            <Typography variant="subtitle2" className={classes.mainTypography}>
              Proposal Details
            </Typography>
            <Typography
              variant="subtitle2"
              className={classes.secondTypography}
            >
              Sent to the applicant
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" className={classes.boldTypography}>
            {proposalTitle}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box textAlign="left" >
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography
                  variant="subtitle2"
                  className={classes.boldTypography}
                >
                  Proposal ID
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.typography}>
                  {proposalId}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="subtitle2"
                  className={classes.boldTypography}
                >
                  Submitted by
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.typography}>
                  {submittedBy}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="subtitle2"
                  className={classes.boldTypography}
                >
                  Evaluated by
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.typography}>
                  {evaluateBy}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProposalDetails;
